<template>
<v-form >
  <request-status :request='req' />
  <v-card>
    <v-card-text>
      <v-radio-group v-model="notification.type" row >
        <v-radio label="Email" value="Email" />
        <v-radio label="SMS" value="SMS" />
      </v-radio-group>

      <v-text-field outlined
        label='Subject'
        v-if='notification.type === "Email"'
        v-model='notification.subject' />

      <v-textarea outlined v-model='notification.message' label='message' rows=12 />
    </v-card-text>
    <v-card-actions >
      <v-spacer />
      {{notification.id}}
      <v-btn @click='save' color='primary' :loading='req.loading' >Save</v-btn>
    </v-card-actions>
    <!-- <pre v-text='notification' /> -->
  </v-card>
</v-form>
</template>
<script>
export default {
  name: 'NotificationForm',
  props: {
    value: { type: Object, required: true }
  },
  data () {
    return {
      notification: {},
      req: {
        resource: 'ag.practitioner.notifications'
      }
    }
  },
  computed: {
    reqStatus () {
      return this.req.status
    }
  },
  methods: {
    save () {
      this.req.data = {
        name: this.notification.name,
        description: this.notification.description,
        practitioner: this.notification.practitioner,
        message: this.notification.message,
        type: this.notification.type,
        slug: this.notification.slug
      }
      if (this.notification.slug) {
        this.req.data.subject = this.notification.subject
      }
      if (this.notification.id) {
        this.req.resourceId = this.notification.slug
      }
      this.$request('save', this.req)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) { this.notification = this.value }
      }
    },
    reqStatus () {
      if (this.reqStatus === 201) {
        this.notification = this.req.result
        this.$emit('saved', this.notification)
      }
      if (this.reqStatus === 200) {
        this.$emit('saved', this.notification)
      }
    }
  }
}
</script>
